import React from "react";
import { NavLink } from "react-router-dom";
import { X, LayoutDashboard, Users, Briefcase, DollarSign, LifeBuoy, Package, Shield } from "lucide-react";

const navLinks = [
  { name: "Dashboard", href: "/admin", icon: LayoutDashboard },
  { name: "Users", href: "/admin/users", icon: Users },
  { name: "Creators", href: "/admin/creators", icon: Briefcase },
  { name: "Opportunities", href: "/admin/opportunities", icon: DollarSign },
  { name: "Inventory", href: "/admin/monetization/inventory", icon: Package },
  { name: "Inventory", href: "/admin/monetization/inventory", icon: Package },
  { name: "Audit Logs", href: "/admin/audit", icon: Shield },
  { name: "Support", href: "/admin/support", icon: LifeBuoy },
];

const getNavLinkClasses = ({ isActive }) =>
  `flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
    isActive
      ? "bg-purple-700 text-white"
      : "text-slate-300 hover:bg-slate-700 hover:text-white"
  }`;

const AdminMobileDrawer = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="sm:hidden fixed inset-0 bg-black/50 z-40"
        onClick={onClose}
      />

      {/* Drawer */}
      <div className="sm:hidden fixed inset-y-0 left-0 w-64 bg-slate-800 text-white z-50 flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-slate-700">
          <div className="flex items-center">
            <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center font-bold text-xl">
              A
            </div>
            <h1 className="ml-3 text-xl font-bold">Adnaki Admin</h1>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-slate-700 rounded-md transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
          {navLinks.map((link) => (
            <NavLink
              key={link.name}
              to={link.href}
              end={link.href === "/admin"}
              className={getNavLinkClasses}
              onClick={onClose}
            >
              <link.icon className="w-5 h-5 mr-3" />
              <span>{link.name}</span>
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-slate-700">
          <p className="text-xs text-slate-400">© 2025 Adnaki Inc.</p>
        </div>
      </div>
    </>
  );
};

export default AdminMobileDrawer;
